export type Lang = 'ru' | 'en';

export interface Dict {
  brand: string;
  tag: string;
  building: string;
  errTitle: string;
  errBody: string;
  hint: string;
  now: string;
  paused: string;
  comments: string;
  write: string;
  you: string;
  noC: string;
  shuffleOn: string;
  shuffleOff: string;
  m3d: string;
  mList: string;
  weather: string;
  seq: string;
  dj: string;
  allTracks: string;
  devTitle: string;
  dvBeat: string;
  dvParticles: string;
  dvFlyby: string;
  dvCovers: string;
  dvLight: string;
  dvBloom: string;
  dvSat: string;
}

/** Словари RU/EN — порт 1:1 из концепта. */
export function dict(lang: Lang, _N: number): Dict {
  const ru: Dict = {
    brand: 'ПанганФМ',
    tag: 'Настроение для жизни',
    building: 'строим спираль…',
    errTitle: 'сцена не загрузилась',
    errBody: 'не удалось подгрузить 3D-движок. проверьте сеть и обновите страницу.',
    hint: 'колесо / ▲▼ — прыжок по трекам · перетащите — обзор · клик по обложке — прыгнуть',
    now: 'сейчас играет',
    paused: 'на паузе',
    comments: 'комментарии',
    write: 'написать комментарий…',
    you: 'вы',
    noC: 'пока нет комментариев — оставьте первый',
    shuffleOn: 'автодиджей',
    shuffleOff: 'по очереди',
    m3d: '3D',
    mList: 'Список',
    weather: 'Погода',
    seq: 'по очереди',
    dj: 'автодиджей микс',
    allTracks: 'треки',
    devTitle: 'Настройки сцены',
    dvBeat: 'Чувствительность к биту',
    dvParticles: 'Плотность частиц',
    dvFlyby: 'Частота пролётов',
    dvCovers: 'Гигантские обложки',
    dvLight: 'Свет',
    dvBloom: 'Свечение',
    dvSat: 'Насыщенность',
  };
  const en: Dict = {
    brand: 'PhanganFM',
    tag: 'Mood for life',
    building: 'building the spiral…',
    errTitle: 'scene failed to load',
    errBody: 'could not load the 3D engine. check your connection and refresh.',
    hint: 'wheel / ▲▼ — hop between tracks · drag — look around · click a cover — jump',
    now: 'now playing',
    paused: 'paused',
    comments: 'comments',
    write: 'write a comment…',
    you: 'you',
    noC: 'no comments yet — be the first',
    shuffleOn: 'auto-DJ',
    shuffleOff: 'in order',
    m3d: '3D',
    mList: 'List',
    weather: 'Weather',
    seq: 'in order',
    dj: 'auto-DJ mix',
    allTracks: 'tracks',
    devTitle: 'Scene controls',
    dvBeat: 'Beat sensitivity',
    dvParticles: 'Particle density',
    dvFlyby: 'Fly-by frequency',
    dvCovers: 'Giant covers',
    dvLight: 'Light',
    dvBloom: 'Glow',
    dvSat: 'Saturation',
  };
  return lang === 'en' ? en : ru;
}
